import { EmployeeRangeOptions } from 'components/UpgradePlan/types';
import * as yup from 'yup';

import { FormLabelText } from './constants';

const DEFAULT_OPTION = 'default';

export const getUpgradePlanFormSchema = () => {
  return yup.object().shape({
    street: yup.string().required(FormLabelText.STREET_ERROR_TEXT),
    zip: yup.string().required(FormLabelText.ZIP_ERROR_TEXT),
    industry: yup
      .string()
      .notOneOf([DEFAULT_OPTION], FormLabelText.INDUSTRY_ERROR_TEXT),
    city: yup.string().notOneOf(['City'], FormLabelText.CITY_ERROR_TEXT),
    reason: yup
      .string()
      .notOneOf([DEFAULT_OPTION], FormLabelText.REASON_ERROR_TEXT),
    no_of_employees: yup
      .string()
      .notOneOf(
        [EmployeeRangeOptions[0].value.toString()],
        FormLabelText.EMPLOYEE_ERROR_TEXT
      )
  });
};
